import React, { useEffect, useRef, useState } from 'react'
import './prereq-form.styles.scss';

import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import ItemSelector from './item-selector.component';
import { useSelector } from 'react-redux';


const PrereqForm = ({
  type,
  formData,
  saveData,
  gameData,
  gameStats,
  gameElements,
  availableItems,
  teams,
  disabled
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [levels, setLevels] = useState([]);
  const [badges, setBadges] = useState([]);
  const [selectedBadges, setSelectedBadges] = useState([]);
  const badgesRef = useRef();
  const [ collections, setCollections ] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [ selectedCollections, setSelectedCollections ] = useState([]);
  const itemsRef = useRef();
  const [teamsToDisplay, setTeamsToDisplay] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const teamsRef = useRef();
  const collectionsRef = useRef();

  useEffect(() => {
    if (!gameElements) { return; }
    setLevels(Object.values(gameElements).filter(c => c.type === 'level' && c.status === 'active'));
    setBadges(Object.values(gameElements).filter(c => c.type === 'badge' && c.status === 'active'));
    badgesRef.current = [];
    setItems(Object.values(gameElements).filter(c => c.type === 'item' && c.status === 'active'));
    itemsRef.current = [];
    setCollections(Object.values(gameElements).filter(c => c.type === 'collection' && c.status === 'active'));
    collectionsRef.current = [];
  }, [gameElements])

  useEffect(() => {
    if (!teams) return;
    setTeamsToDisplay([...teams]);
    teamsRef.current = [];
  }, [teams])

  useEffect(() => {
    if (!formData) { return; }
    if (formData.opt_prereqBadges && formData.opt_prereqBadges.length > 0) {
      badgesRef.current = [...formData.opt_prereqBadges]
      setSelectedBadges(badgesRef.current);
    }
    if (formData.opt_prereqItems && formData.opt_prereqItems.length > 0) {
      itemsRef.current = [...formData.opt_prereqItems];
      setSelectedItems(itemsRef.current);
    }
    if (formData.opt_prereqTeams && formData.opt_prereqTeams.length > 0) {
      teamsRef.current = [...formData.opt_prereqTeams];
      setSelectedTeams(teamsRef.current);
    }
    if (formData.opt_prereqCollections && formData.opt_prereqCollections.length > 0) {
      collectionsRef.current = [...formData.opt_prereqCollections];
      setSelectedCollections(collectionsRef.current);
    }
  }, [formData])

  useEffect(() => {
    if (disabled) {
      saveData('opt_prereqPoints', null);
      saveData('opt_prereqLevel', null);
      badgesRef.current = [];
      setSelectedBadges([...badgesRef.current]);
      saveData('opt_prereqBadges', badgesRef.current);
      itemsRef.current = [];
      setSelectedItems([...itemsRef.current]);
      saveData('opt_prereqItems', itemsRef.current);
      teamsRef.current = [];
      setSelectedTeams([...teamsRef.current]);
      saveData('opt_prereqTeams', teamsRef.current);
      collectionsRef.current = [];
      setSelectedCollections([...collectionsRef.current]);
      saveData('opt_prereqCollections', collectionsRef.current);
    }
  }, [disabled])

  function search(text, id) {
    if (!text && id) {
      if (id === "badge") {
        setBadges(Object.values(gameElements).filter(c => c.type === 'badge' && c.status === 'active'));
      } else if (id === 'item') {
        setItems(Object.values(gameElements).filter(c => c.type === 'item' && c.status === 'active'));
      } else if (id === 'team') {
        setTeamsToDisplay([...teams])
      }
    } else if (id === 'team') {
      const filteredTeams = Object.values(teams)
        .filter(t => t.name.toLowerCase().includes(text.toLowerCase()))
      setTeamsToDisplay(filteredTeams);
    } else {
      const filteredElements = Object.values(gameElements)
        .filter(
          c => c.type === id &&
            c.status === 'active' &&
            (
              c.name.toLowerCase().includes(text.toLowerCase()) ||
              (
                c.desc &&
                c.desc.toLowerCase().includes(text.toLowerCase())
              )
            )
        )
      if (id === 'badge') {
        setBadges(filteredElements);
      } else if (id === 'item') {
        setItems(filteredElements);
      } else if (id === 'collection') {
        setCollections(filteredElements);
      }
    }
  }

  function chooseMultipleOption(id, category) {
    let tempList;
    if (category === 'badges') {
      tempList = [...badgesRef.current];
      if (tempList.includes(id)) {
        tempList.splice(tempList.indexOf(id), 1);
      } else {
        tempList.push(id);
      }
      badgesRef.current = tempList;
      setSelectedBadges(badgesRef.current);
      saveData('opt_prereqBadges', badgesRef.current);
    }
    else if (category === 'items') {
      tempList = [...itemsRef.current];
      if (tempList.includes(id)) {
        tempList.splice(tempList.indexOf(id), 1);
      } else {
        tempList.push(id);
      }
      itemsRef.current = tempList;
      setSelectedItems(itemsRef.current);
      saveData('opt_prereqItems', itemsRef.current);
    }
    else if (category === 'teams') {
      tempList = [...teamsRef.current];
      if (tempList.includes(id)) {
        tempList.splice(tempList.indexOf(id), 1);
        console.log('removing team')
      } else {
        tempList.push(id);
        console.log('adding team')
      }
      teamsRef.current = [...tempList];
      setSelectedTeams(teamsRef.current);
      saveData('opt_prereqTeams', teamsRef.current);
    }
    else if (category === 'collections') {
      tempList = [...collectionsRef.current];
      if (tempList.includes(id)) {
        tempList.splice(tempList.indexOf(id), 1);
      } else {
        tempList.push(id);
      }
      collectionsRef.current = [...tempList];
      setSelectedCollections(collectionsRef.current);
      saveData('opt_prereqCollections', collectionsRef.current);
    }
  }

  return (
    <div className={`prereq-form ${screenSize}`}>
      <div className={`field small ${disabled ? 'disabled' : ''}`}>
        <label>What Level should a player achieve before being allowed to access this {type}?</label>
        {/* <div className={
          screenSize === 'mobile' || screenSize === 'tablet'
            ? 'columns'
            : 'g-double-col'
        }>
          <input
            type='number'
            className=''
            placeholder='Min Points'
            value={formData.opt_prereqPoints ?? ''}
            onChange={(e) => saveData('opt_prereqPoints', Number(e.target.value))}
          /> */}
          <div className='g-list-item multiple-select'>
            <div className='select-list'>
              {
                levels.length > 0
                  ? levels.sort((a, b) => a.opt_pointMinimum > b.opt_pointMinimum ? 1 : -1)
                    .map(l => (
                      <div
                        key={l.id}
                        className={`multiple-select-option has-display-arr level ${formData.opt_prereqLevel === l.id ? 'active' : ''}`}
                        onClick={() => saveData('opt_prereqLevel', formData.opt_prereqLevel === l.id ? null : l.id)}
                      >
                        <ImageContainer src={l.icon} alt={`${l.name} level icon`} />
                        <div className='level-name'>{l.name}</div>
                        <div className='level-points meta'>{l.opt_pointMinimum} XP</div>
                      </div>
                    ))
                  : <span>No Levels...</span>
              }
            </div>
          </div>
        {/* </div> */}
      </div>
      <div className="g-space-2"></div>
      <div className={`field small ${disabled ? 'disabled' : ''}`}>
        <label>What Badge(s) should a player earn before being allowed to access this {type}?</label>
        <div className='g-list-item multiple-select'>
          <SearchBar search={search} idLabel="badge" />
          <div className='select-list'>
            {
              (badges.length > 0)
                ?
                badges.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                  .map(b => (
                    <div
                      key={b.id}
                      className={`multiple-select-option badge ${selectedBadges.includes(b.id) ? 'active' : ''}`} onClick={() => chooseMultipleOption(b.id, 'badges')}>
                      <ImageContainer src={b.icon} alt={`${b.name} badge icon`} />
                      {b.name}
                    </div>
                  ))
                :
                <span>No Badges...</span>
            }
          </div>
        </div>
      </div>
      
      <div className="g-space-2"></div>
      <div className={disabled ? 'disabled' : ''}>
        <ItemSelector
          type='prereq'
          formData={formData}
          saveData={saveData}
          gameElements={availableItems}
          gameData={gameData}
          gameStats={gameStats}
          inst={`What Inventory Item(s) should a player own before being allowed to access this ${type}?`}
          saveKey='opt_prereqItems'
        />
      </div>
      <div className="g-space-2"></div>
      <div className={`field small ${disabled ? 'disabled' : ''}`}>
        <label>What Collection(s) should a player earn before being allowed to access this {type}?</label>
        <div className='g-list-item multiple-select'>
          <SearchBar search={search} idLabel="collection" />
          <div className='select-list'>
            {
              (collections.length > 0)
                ?
                collections.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                  .map(c => (
                    <div
                      key={c.id}
                      className={`multiple-select-option collection ${selectedCollections.includes(c.id) ? 'active' : ''}`}
                      onClick={() => chooseMultipleOption(c.id, 'collections')}
                    >
                      <ImageContainer src={c.icon} alt={`${c.name} collection icon`} />
                      {c.name}
                    </div>
                  ))
                :
                <span>No Collections...</span>
            }
          </div>
        </div>
      </div>
      <div className="g-space-2"></div>
      <div className={`field small ${disabled ? 'disabled' : ''}`}>
        <label>Of what Team(s) should a player be a member before being allowed to access this {type}?</label>
        <div className='g-list-item multiple-select'>
          <SearchBar search={search} idLabel="team" />
          <div className='select-list'>
            {
              (teamsToDisplay.length > 0)
                ?
                teamsToDisplay.sort((a, b) =>
                  a.displayName.toLowerCase() > b.displayName.toLowerCase()
                    ? 1
                    : -1
                )
                  .map(t => (
                    <div
                      key={t.playerId}
                      className={`multiple-select-option ${selectedTeams.includes(t.playerId) ? 'active' : ''}`}
                      onClick={() => chooseMultipleOption(t.playerId, 'teams')}
                    >
                      <ImageContainer src={t.icon} alt={`${t.displayName} team icon`} />
                      {t.displayName}
                    </div>
                  ))
                :
                <span>No Teams Yet...</span>
            }
          </div>
        </div>
      </div>
      <div className="g-space-1"></div>
    </div>
  )
}

export default PrereqForm;